import type { MembershipTier } from "@/models/membershipTier";
import type { User } from "@/models/user";
import type { MembershipAffinity } from "@/models/membershipAffinity";
import type { MembershipSubscription } from "@/models/membershipSubscription";
import type { MembershipTierPlan } from '@/models/membershipTierPlan';
import type { ReferralCode } from "@/models/referral";
import type { Destination } from "@/models/destination";

export enum MembershipImportStatus {
  INCOMPLETE = 'incomplete',
  COMPLETE = 'complete',
}

export enum MembershipStatus {
  ABANDONED_CHECKOUT = 'abandoned_checkout',
  ACTIVE = 'active',
  OVERDUE = 'overdue',
  SUSPENDED = 'suspended',
  CHURNED = 'churned',
}

export type Membership = {
  id: number;
  userId: number;
  clientId: number;
  newsletter: boolean;
  createdAt: string;
  updatedAt: string;
  maxRoundUp: number;
  referralRockMemberId?: string;
  referralRockParentId?: string;
  affiliateProgram: string | null;
  importStatus: MembershipImportStatus | null;

  user?: User;

  status: MembershipStatus;
  membershipTierId?: number | null;
  membershipTierPlanId?: number | null;
  membershipTier?: MembershipTier | null;
  membershipTierPlan?: MembershipTierPlan | null;
  membershipSubscriptions?: MembershipSubscription[];
  currentSubscription?: MembershipSubscription | null;

  affinities: MembershipAffinity[];

  /* New referral system */
  referralCode?: ReferralCode | null;
  referralCodes?: ReferralCode[] | null;

  /* Destinations */
  destinations?: Destination[] | null;
};

export type MembershipContribution = {
  roundUps: number;
  rewards: number;
};
export type MembershipContributionIntervals = {
  [ key: string ]: MembershipContribution;
}
export type MembershipContributions = {
  total: MembershipContribution;
} & MembershipContributionIntervals;
